import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const ShiftReviewFormContainer = styled.div.attrs({
  className: 'ShiftReviewFormContainer',
})`
  .Title {
    font-size: 1.625rem;
    margin-bottom: 0;
    line-height: 2rem;
    color: ${themed('primary.main')};
    margin-bottom: 0.25rem;
  }

  & > .Text {
    font-size: 1rem;
    line-height: 1.75rem;
    letter-spacing: 0.02rem;
    margin-bottom: 1rem;
  }

  .component__label {
    margin-bottom: 0.1rem;
  }

  .NotificationStyled, .ErrorNotice {
    margin-bottom: 1rem;
    margin-top: 0;
  }

  span {
    font-size: 1rem;
    font-weight: 700;
    color: ${themed('primary.accent')};
    margin-top: 0.5rem;
  }

  a {
    text-decoration: none;
    color: ${themed('primary.accent')};
  }
`;

export const ShiftDetails = styled.div.attrs({
  className: 'ShiftDetails',
})`
  margin-top: 1rem;
  margin-bottom: .8rem;

  p {
    margin-bottom: 0.4rem;
  }
`;

export const TextAreaWrapper = styled.div.attrs({
  className: 'TextAreaWrapper',
})`
  margin-bottom: 0.8rem;
`;
